export default __webpack_public_path__ + "static/media/portfolio-134.48974587.jpg";